export const text = {
  enterVerifyCode: "Enter Verification Code",
  changeMobileNumber: "Change Mobile Number",
  myProfile: "My Profile",
  subScriptionPlan: "Subscription Plans",
  billingHistory: "Billing History",
  emailId: "Email Id",
  changeEmail: "Change Email",
  verifyNumber: "Verify Number",
  changePhoneNumber: "Change Phone Number",
  switchingThePlan: "Switching the Plan?",
  youHaveAlreaddyActivePlanInYourProfile:
    "You already have Standard Plan active in your profile.",
  ifYouWantToSwitchThePlan: "If you want to switch the plan",
  pleaseClickOnContinue: "please click on continue",
  manageSubscription: "Manage Subscription",
  enterVerificationCode: "Enter Verification Code✍️",
  yourCurrentEmailIs: "Your current email is",
  sendATemporaryVerificationCodeToThisEmail:
    "We'll send a temporary verification code to this email.",
  enterVerificationCodeSentToYourMobileNumber:
    "Enter verification code sent to your mobile number",
  mobileNumberChanged: "Mobile Number Changed",
  mobileNumberVerify: "Mobile Number Verify",
  emailIdUpdated: "Email ID Updated",
  changeEmailAddress: "Change Email Address",
  newEmailAddress: "New Email Address",
  emailAddressPlaceholder: "Enter New Email Address",
  planCancellation:
    "On cancellation of this plan, the plan's validity period will remain until its expiration date and Auto-Renewal will be deactivated",
  youWantToDisableRenewal: "you want to disable auto renewal?",
  subscriptionPlans: "Subscription Plans",
  autoRenewalIsOn: "Auto-Renewal is On",
  enterEmailId: "Enter Email id",
  notVerified: "Not Verified",
  phoneNumber: "Phone Number",
  plan: "Plan",
  subScriptionPrice: "Subscription price",
  dateOfInvoice: "Date of invoice",
  dateOfExpiration: "Date of expiration",
  refund: "Refund",
  paymentMethod: "Payment method",
  proPlan: "Pro Plan",
  enterprisePlan: "Enterprise Plan",
  downloadInvoice: "Download Invoice",
};
